/**
 * Used to adapt the user interface based on the page that is rendered.
 */
export enum Page {
    ADMIN = 'ADMIN',
    TOURS = 'TOURS',
    TOUR = 'TOUR',
    STOP = 'STOP',
    ACTION = 'ACTION',
    RASTER_LOCATION = 'RASTER_LOCATION',
    PROTOCOL = 'PROTOCOL',
    REPORT_ISSUE = 'REPORT_ISSUE',
    SHIFT = 'SHIFT',
    NAME = 'NAME',
    CARGO = 'CARGO', // Used for transport without an instance
    BULK_SIGN = 'BULK_SIGN'
}
